import { helpers } from '@vuelidate/validators';
import { unref } from 'vue-demi';
import _ from 'lodash';
function sameGroupNameAlreadyExists(allGroups, message) {
    return helpers.withMessage(message, (currentGroup) => !helpers.req(currentGroup) ||
        _.filter(unref(allGroups), group => group.name === currentGroup.name &&
            group.groupId !== currentGroup.groupId).length == 0);
}
export default sameGroupNameAlreadyExists;
